/**
 *
 * @module component/templates
 * @author shojib [mahmud.hossain@mlb.com]
 * @description module for adding handlebars templates
 *
 */

import migTemplate from '../../template/mig.html';
import minisbTemplate from '../../template/minisb.html';
import gameSelectorTemplate from '../../template/game-selector.html';
import responsiveTemplate from '../../template/responsive.html';
import postseasonTemplate from '../../template/postseason.html';

/**
 *
 * @name partials
 * @description handlebars partials to be registered
 *
 */
const templates = {
    migTemplate,
    minisbTemplate,
    gameSelectorTemplate,
    responsiveTemplate,
    postseasonTemplate
};

export default templates;
